var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{attrs:{"name":"notification"}}),_c('router-view',{attrs:{"name":"content"}}),_c('router-view',{attrs:{"name":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }